import { makeStyles } from '@material-ui/core/styles';

export const reportStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));
